import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SurveyService } from 'src/app/profile/pages/surveys-page/services/surveys.service';

@Component({
  selector: 'shared-dropdown-emails',
  templateUrl: './dropdown-emails.component.html',
  styleUrls: ['./dropdown-emails.component.scss'],
})
export class DropdownEmailsComponent {
  @Output() selectedValueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedEmailsChange: EventEmitter<string[]> = new EventEmitter<
    string[]
  >();
  @Input() selectedValue: any;
  @Input() selectedEmails: string[] = [];

  public emails: any = [];
  constructor(private surveyService: SurveyService) {}

  ngOnInit(): void {
    this.getAllEmails();
  }

  getAllEmails() {
    this.surveyService.getAllEmails().subscribe({
      next: (response) => {
        this.emails = response;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  addEmail() {
    this.selectedValueChange.emit(this.selectedValue);

    // Limpiar el dropdown para buscar otro
    setTimeout(() => {
      this.selectedValue = '';
    }, 10);

    // Quitando los que ya fueron seleccionados
    this.emails = this.emails.filter(
      (email: any) => !this.selectedEmails.includes(email.email)
    );
  }


  removeSelectedEmail(email: string) {
    const index = this.selectedEmails.indexOf(email);
    if (index !== -1) {
      this.selectedEmails.splice(index, 1);
      this.emails.push({ email: email }); // Vuelve a agregar el correo eliminado a la lista de correos disponibles
      this.selectedEmailsChange.emit([...this.selectedEmails]); // Emitir el evento con la nueva lista
    }
  }

  // Método para agregar un correo electrónico a la lista de correos disponibles
  addAvailableEmail(email: string) {
    this.emails.push({ email: email });
  }
}
